import { render, staticRenderFns } from "./notificationAdd.vue?vue&type=template&id=323f50fc&scoped=true&"
import script from "./notificationAdd.vue?vue&type=script&lang=js&"
export * from "./notificationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f50fc",
  null
  
)

export default component.exports